import { CustomFormItemProps, IFormComponent, } from '@Modules/atlas-form-core';
import { TRequired, } from 'atlas-shared/dist';
import { FormComponentCrud, } from './crud';

export const FormComponentCrudSuperadmin: IFormComponent = (props: TRequired<CustomFormItemProps>) => {
  return <FormComponentCrud {...props} isSuperadminProfile />;
};
